import { Box, Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import Modal from '../Modal';
import { useForm, Form } from '../UseForm';
import Controls from '../Controls';
import http from '../../api/http';

function ModalPreferences({ openModal, closeModal }) {
    const { activeUser, notifyToUser, refreshActiveUser } = useAuth();
    const { varValues, varErrors, setErrors, handleInputChange, setValues } = useForm({
        name: activeUser?.name || '',
        phoneNumber: activeUser?.phoneNumber || '',
        address: activeUser?.address || '',
        city: activeUser?.city || '',
        old_password: '',
        new_password: '',
        confirm_password: '',
    });

    useEffect(() => {
        if (!openModal) {
            return;
        }
        setValues({
            name: activeUser?.name || '',
            phoneNumber: activeUser?.phoneNumber || '',
            address: activeUser?.address || '',
            city: activeUser?.city || '',
            old_password: '',
            new_password: '',
            confirm_password: '',
        });
    }, [activeUser, openModal, setValues]);

    const handleSaveProfile = async (e) => {
        e.preventDefault();
        if (!varValues.name) {
            return setErrors({ name: 'Name is required' });
        }
        try {
            await http.put('/profile/update-preferences', {
                name: varValues.name,
                phoneNumber: varValues.phoneNumber,
                address: varValues.address,
                city: varValues.city,
            });
            if (refreshActiveUser) {
                await refreshActiveUser();
            }
            notifyToUser('success', 'Profile updated');
            closeModal();
        } catch (error) {
            notifyToUser('error', error.response?.data?.message || 'Unable to update profile');
        }
        return undefined;
    };

    const handleChangePassword = async (e) => {
        e.preventDefault();
        const errors = {};
        if (!varValues.old_password) errors.old_password = 'Current password is required';
        if (!varValues.new_password) errors.new_password = 'New password is required';
        if (varValues.new_password !== varValues.confirm_password) {
            errors.confirm_password = 'Passwords do not match';
        }
        if (Object.keys(errors).length) {
            return setErrors(errors);
        }
        try {
            await http.put('/profile/update-password', {
                old_password: varValues.old_password,
                new_password: varValues.new_password,
                confirm_password: varValues.confirm_password,
            });
            notifyToUser('success', 'Password updated');
            closeModal();
        } catch (error) {
            notifyToUser('error', error.response?.data?.message || 'Unable to update password');
        }
        return undefined;
    };

    return (
        <Modal
            title="Profile settings"
            openModal={openModal}
            closeModal={closeModal}
            width="sm"
        >
            <Form onSubmit={handleSaveProfile}>
                <Stack spacing={2}>
                    <Controls.Input
                        name="name"
                        label="Name"
                        value={varValues.name}
                        error={varErrors.name}
                        onChange={handleInputChange}
                    />
                    <Controls.Input
                        name="phoneNumber"
                        label="Phone"
                        value={varValues.phoneNumber}
                        onChange={handleInputChange}
                    />
                    <Controls.Input
                        name="address"
                        label="Address"
                        value={varValues.address}
                        onChange={handleInputChange}
                    />
                    <Controls.Input
                        name="city"
                        label="City"
                        value={varValues.city}
                        onChange={handleInputChange}
                    />
                    <Box sx={{ textAlign: 'right' }}>
                        <LoadingButton type="submit" variant="contained" color="secondary">
                            Save profile
                        </LoadingButton>
                    </Box>
                </Stack>
            </Form>
            <Form onSubmit={handleChangePassword}>
                <Stack spacing={2} sx={{ mt: 4 }}>
                    <Controls.Input
                        name="old_password"
                        label="Current password"
                        type="password"
                        value={varValues.old_password}
                        error={varErrors.old_password}
                        onChange={handleInputChange}
                    />
                    <Controls.Input
                        name="new_password"
                        label="New password"
                        type="password"
                        value={varValues.new_password}
                        error={varErrors.new_password}
                        onChange={handleInputChange}
                    />
                    <Controls.Input
                        name="confirm_password"
                        label="Confirm new password"
                        type="password"
                        value={varValues.confirm_password}
                        error={varErrors.confirm_password}
                        onChange={handleInputChange}
                    />
                    <Box sx={{ textAlign: 'right' }}>
                        <LoadingButton type="submit" variant="outlined" color="secondary">
                            Update password
                        </LoadingButton>
                    </Box>
                </Stack>
            </Form>
        </Modal>
    );
}

export default ModalPreferences;
